import { Accordion } from "common/components/ui/Accordion";
import { typedObjectKeys } from "common/helpers/utils";
import type { ProfileSearchParams } from "common/types";

import { PROFILE_SEARCH_OPTIONS } from "../../../../constants";
import Filter from "./Filter";

interface FiltersProps {
  accountId: string;
  searchParams: ProfileSearchParams;
  setSearchParams: (searchParams: Partial<ProfileSearchParams>) => void;
}

export default function FiltersSelection({
  accountId,
  searchParams,
  setSearchParams,
}: FiltersProps) {
  return (
    <Accordion
      collapsible
      type="single"
      className="flex flex-col overflow-hidden"
    >
      {typedObjectKeys(PROFILE_SEARCH_OPTIONS).map((optionsKey) => (
        <Filter
          key={optionsKey}
          optionsKey={optionsKey}
          accountId={accountId}
          searchParams={searchParams}
          setSearchParams={setSearchParams}
        />
      ))}
    </Accordion>
  );
}
